import { render, staticRenderFns } from "./importWizard.vue?vue&type=template&id=145ce70b"
import script from "./importWizard.vue?vue&type=script&lang=js"
export * from "./importWizard.vue?vue&type=script&lang=js"
import style0 from "./importWizard.vue?vue&type=style&index=0&id=145ce70b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports